<ion-content [fullscreen]="true" [style.--background]="scanActive?'#00000000':'#ffffff'">
  <ion-button (click)="toggleTorch()">torch</ion-button>

  <div class="divMessage">
    <div>
      <p>Aponte para o codigo de barras</p>
    </div>
  </div>

  <div class="divCentral">
    <div id="cameraPreview" class="cameraPreview">
      <div class="vertical-line"></div>
    </div>
  </div>
  <!-- <div class="scan-box" [hidden]="!scanActive"></div> -->

</ion-content>